/**
 * Load Demandbase tracking script
 * This should be called once during application initialization
 */
export const loadDemandBase = () => {
  // Check if script already loaded
  const existingScript = document.getElementById('demandbase_js_lib');
  if (existingScript) {
    console.log('Demandbase script already loaded');
    return;
  }

  console.log('Loading Demandbase script...');

  (function (a, b, c, d, e) {
    a = b.createElement(c);
    b = b.getElementsByTagName(c)[0];
    a.async = 1;
    a.id = e;
    a.src = d;
    b.parentNode.insertBefore(a, b);
  })(window, document, 'script', 'https://tag.demandbase.com/CYQJ73kQ.min.js', 'demandbase_js_lib');
};
